import { Text, View } from '@react-pdf/renderer';

import styles from './FooterStyles.ts';

const Footer = () => (
  <View style={styles.container} fixed>
    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} />
  </View>
);

export default Footer;
